export const SocialPostKind = {
    INSTAGRAM_STORIES: 'Instagram Stories',
    INSTAGRAM_CAROUSEL: 'Instagram Carousel',
    INSTAGRAM_SINGLE_MEDIA_POST: 'Instagram Single Media Post',
    INSTAGRAM_REEL: 'Instagram Reel',
    FACEBOOK_IMAGE_STORIES: 'Facebook Image Stories',
    FACEBOOK_VIDEO_STORIES: 'Facebook Video Stories',
    FACEBOOK_INFEED_IMAGE: 'Facebook In-Feed Image',
    FACEBOOK_INFEED_VIDEO: 'Facebook In-Feed Video',
    TIKTOK_INFEED_VIDEO: 'TikTok In-Feed Video',
    TIKTOK_BRAND_TAKEOVER: 'TikTok Brand Takeover',
    TIKTOK_TOP_VIEW: 'TikTok Top View',
    TWITTER_PROMOTED_IMAGE: 'Twitter Promoted Image',
    TWITTER_CAROUSEL_IMAGE: 'Twitter Carousel Image',
    TWITTER_PROMOTED_VIDEO: 'Twitter Promoted Video',
    TWITTER_CAROUSEL_VIDEO: 'Twitter Carousel Video',
    YOUTUBE_INSTREAM_SKIPPABLE: 'YouTube In-stream',
    YOUTUBE_INSTREAM_NONSKIPPABLE: 'YouTube In-Stream Non-Skippable',
    YOUTUBE_BUMPER_AD: 'YouTube Bumper Ad',
    YOUTUBE_MASTHEAD: 'YouTube Masthead',
    PINTEREST_SINGLE_IMAGE: 'Pinterest Single Image',
    PINTEREST_PROMOTED_VIDEO: 'Pinterest Promoted Video',
    PINTEREST_FEED_CAROUSEL: 'Pinterest Feed Carousel',
    SNAPCHAT_SNAP_AD_IMAGE: 'Snapchat Snap Ad Image',
    SNAPCHAT_SNAP_AD_VIDEO: 'Snapchat Snap Ad Video',
    SNAPCHAT_STORY_AD_IMAGE: 'Snapchat Story Ad Image',
    SNAPCHAT_STORY_AD_VIDEO: 'Snapchat Story Ad Video',
    OTHER_SOCIAL_IMAGE: 'Other Social Image',
    OTHER_SOCIAL_VIDEO: 'Other Social Video'
};



// WEBPACK FOOTER //
// ./common/language/content_component/social_post_kind.js